/**
 * 小游戏抽奖方式
 * @author honggexuan
 * @since 19/03/19
 */

import { SET_LOTTERY_INFO, SHOW_TIPS } from 'constants/action.json5';

// export const setLotteryInfo = data => {
//   return {
//     type: SET_LOTTERY_INFO,

//   };
// };

export function setLotteryInfo(data) {
  return {
    type: SET_LOTTERY_INFO,
    payload: data,
  };
}

export function setShowTips(data) {
  return {
    type: SHOW_TIPS,
    payload: data,
  };
}
